import { createComponentPreviewEntry } from '@wix/editor-elements-integrations';
import { withComponentPreview } from '@wix/editor-elements-preview-utils';
import React from 'react';
import { IPinterestPinItProps } from '../PinterestPinIt.types';

export default (ViewerComponent: React.ComponentType<IPinterestPinItProps>) =>
  createComponentPreviewEntry(withComponentPreview(ViewerComponent as any));
